export const ADDEDPRODUCT = "addedproduct";
export const ADDED = "added";
export const REMOVE = "remove";
export const INCREMENT = "increment";
export const DECREMENT = "decrement";
